import { QueryClientProvider, type QueryClient } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'
import type { Api } from './api'
import { ApiContext } from './api-context'
import { createQueryClient } from './query-client'
import { SessionProvider } from './session-provider'
import type { TokenStore } from './token-store'

/**
 * Tudo que uma página precisa em volta: cache de leitura (TanStack Query), cliente da API e a
 * sessão do portal. `main.tsx` passa o cliente e o cofre do token reais; os testes passam os falsos.
 */
export function AppProviders({
  api,
  store,
  queryClient,
  children,
}: {
  api: Api
  store: TokenStore
  queryClient?: QueryClient
  children: ReactNode
}) {
  const [client] = useState(() => queryClient ?? createQueryClient())
  return (
    <QueryClientProvider client={client}>
      <ApiContext.Provider value={api}>
        <SessionProvider store={store}>{children}</SessionProvider>
      </ApiContext.Provider>
    </QueryClientProvider>
  )
}
